<template>
  <div class="loading-wrapper" v-if="isLoading">
    <div style="display: flex;justify-content: center;">
      <div class="loading-border"></div>
      <div class="loading-logo-wrapper">
        <img
          class="loading-logo"
          src="https://cdn.parcelex.com.br/assets/v2/logo-alt.svg"
          alt="Loading"
          title="Loading"
        >
      </div>
    </div>
    <div class="loading-text">{{ loadingText }}</div>
  </div>
</template>

<script>
export default {
  name: 'loader',
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
    loadingText: {
      type: String,
      default: 'Carregando...',
    },
  },
};
</script>

<style style="scss" scoped>
  .loading-wrapper {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 213px;
    min-height: 126px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
  }

  .loading-border {
    align-self: center;
    border: 6px solid;
    width: 84px;
    height: 84px;
    border-radius: 50%;
    border-color: #36A3CA #36A3CA transparent;
    animation: splash-loading-spinner 1s linear infinite;position: absolute;
  }

  .loading-logo-wrapper {
    position: relative;
    background: #DFE3E8;
    border-radius: 50%;
    width: 78px;
    height: 78px;
  }

  .loading-logo {
    width: 36px;
    height: 36px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .loading-text {
    position: absolute;
    margin-top: 95px;
    text-align: center;
    font-weight: 400;
    font-size: 20px;
    line-height: 28px;
    font-feature-settings: 'ordn' on;
    color: #454F5B;
  }
</style>
